<template>
    <td :class="roomStatusColor" class="room-cell">
        <v-menu v-if="roomStatusColor !== 'bg-green-lighten-2'" :close-on-content-click="true" absolute>
            <template v-slot:activator="{props}">
                <div class="fill" v-bind="props" />
            </template>
            <v-card class="pa-1 pl-1">
                <v-card-subtitle class="pa-0 text-center font-weight-bold">
                    {{ $filters.dateShortFormat(date) }}
                </v-card-subtitle>
                <v-radio-group :model-value="roomStatus" class="pl-2" @update:model-value="changeRoomStatus">
                    <v-radio value="bookable">
                        <template v-slot:label>
                            <div class="d-flex align-center justify-space-between full-width">
                                {{ $t('supplier.bookable') }}
                                <v-icon class="text-green">mdi-checkbox-blank-circle</v-icon>
                            </div>
                        </template>
                    </v-radio>
                    <v-radio value="closed">
                        <template v-slot:label>
                            <div class="d-flex align-center justify-space-between full-width">
                                {{ $t('supplier.closed') }}
                                <v-icon class="text-red">mdi-checkbox-blank-circle</v-icon>
                            </div>
                        </template>
                    </v-radio>
                </v-radio-group>
            </v-card>
        </v-menu>
    </td>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component({})
    export class RoomStatusCell extends Vue {
        @Prop() date
        @Prop() service

        get roomStatus() {
            switch (this.roomStatusColor) {
                case 'bg-green-lighten-2':
                    return 'bookable'
                case 'bg-red-lighten-2':
                    return 'closed'
                default:
                    return 'no_room'
            }
        }

        get roomStatusColor() {
            if (this.service.blockout) {
                return 'bg-red-lighten-2'
            }
            switch (this.service.status) {
                case 'NOT_AVAILABLE':
                    return 'bg-grey-lighten-2'
                case 'BLOCKED':
                    return 'bg-red-lighten-2'
                case 'AVAILABLE':
                    return 'bg-green-lighten-2'
                case 'RELEASED':
                case 'UNLIMITED':
                case 'OVERBOOKING':
                    if (this.service.availableQuantity > 0) {
                        return 'bg-green-lighten-2'
                    } else {
                        return 'bg-grey-lighten-2'
                    }
                default:
                    return 'bg-grey-lighten-2'
            }
        }

        changeRoomStatus(value) {
            this.$emit('update', {
                dateFrom: this.date,
                dateTo: this.date,
                categoryId: this.service.categoryId,
                serviceId: this.service.serviceId,
                operation: value === 'bookable' ? 'CLEAR_BLOCK' : 'BLOCK',
                dayOfWeek: [true, true, true, true, true, true, true],
            })
        }
    }

    export default RoomStatusCell
</script>

<style scoped lang="scss">
    .fill {
        height: 100%;
    }
    .full-width {
        width: 100%;
    }
</style>
